module.exports = __webpack_public_path__ + "static/media/reset-icon.acf33985.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reset-icon.svg
// module id = 367
// module chunks = 0